(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["book-us-landing-inner"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-mse-package-slideshow]').forEach(function (root) {
      var slides = root.querySelectorAll('.mse-landing__slide');
      if (slides.length < 2) return;
      var i = 0;
      var ms = (parseInt(root.getAttribute('data-interval'), 10) || 5) * 1000;
      window.setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, ms);
    });

    function mseInitFrameDecoShuffle() {
      var frameSection = document.querySelector('[data-mse-frames-section]');
      var poolTpl = document.getElementById('mse-bookus-frame-pool');
      if (!frameSection || !poolTpl || !poolTpl.content) return;
      var poolImgs = poolTpl.content.querySelectorAll('img.mse-frame-pool-img');
      var urls = [];
      for (var p = 0; p < poolImgs.length; p++) {
        var href = poolImgs[p].getAttribute('src') || poolImgs[p].src;
        if (href && href.indexOf('data:') !== 0) urls.push(href);
      }
      if (!urls.length) return;
      for (var u = urls.length - 1; u > 0; u--) {
        var j = Math.floor(Math.random() * (u + 1));
        var t = urls[u];
        urls[u] = urls[j];
        urls[j] = t;
      }
      var slots = frameSection.querySelectorAll('[data-mse-frame-slot]');
      for (var s = 0; s < slots.length; s++) {
        slots[s].src = urls[s % urls.length];
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mseInitFrameDecoShuffle);
    } else {
      mseInitFrameDecoShuffle();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
